import { Navigate } from 'react-router-dom';
import { isTokenExpired } from './tokenUtils';
import { canContinuePreparedOffline } from '../offline/offlineSession';
import { rememberPostLoginRedirect } from '../utils/postLoginRedirect';
import OfflineVaultGate from '../components/OfflineVaultAccess';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('velaToken');
  if ((!token || isTokenExpired(token)) && !canContinuePreparedOffline()) {
    rememberPostLoginRedirect();
    localStorage.removeItem('velaToken');
    return <Navigate to="/login" replace />;
  }

  return <OfflineVaultGate>{children}</OfflineVaultGate>;
};

export default ProtectedRoute;
